import { motion, useInView, useMotionValue, useTransform, animate } from 'framer-motion';
import { useRef, useEffect, useState } from 'react';

const stats = [
  { value: 50000, suffix: '+', label: 'plateaux tracés' },
  { value: 8, suffix: '', label: 'disciplines supportées' },
  { value: 3, suffix: '', label: 'analyses disponibles' },
  { value: 7, suffix: ' jours', label: "d'essai gratuit" },
];

function Counter({ target, suffix, isDecimal = false }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const [displayVal, setDisplayVal] = useState(0);

  useEffect(() => {
    if (!isInView) return;
    const controls = animate(0, target, {
      duration: 2,
      ease: 'easeOut',
      onUpdate: (v) => setDisplayVal(isDecimal ? parseFloat(v.toFixed(1)) : Math.floor(v)),
    });
    return () => controls.stop();
  }, [isInView, target, isDecimal]);

  return (
    <span ref={ref} className="text-4xl sm:text-5xl font-black font-['Poppins'] gradient-text">
      {isDecimal ? displayVal.toFixed(1) : displayVal.toLocaleString('fr-FR')}
      {suffix}
    </span>
  );
}

export default function StatsCounters() {
  return (
    <section data-testid="stats-section" className="py-24 sm:py-32 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0D0D0D] via-[#1A1A1A]/30 to-[#0D0D0D]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1, duration: 0.5 }}
              data-testid={`stat-${i}`}
              className="text-center"
            >
              <Counter target={stat.value} suffix={stat.suffix} isDecimal={stat.isDecimal} />
              <p className="text-[#A0A0A0] text-sm mt-2 font-medium">{stat.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
